/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [!_vm.closed ? _c('div', {
    class: _vm.wrapClasses
  }, [_c('span', {
    class: _vm.messageClasses
  }, [_vm._t("default")], 2), _c('span', {
    class: _vm.descClasses
  }, [_vm._t("desc")], 2), _vm.closable ? _c('a', {
    class: _vm.closeClasses,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_vm._t("close", function () {
    return [_c('span', {
      staticClass: "vux-close close-btn"
    })];
  })], 2) : _vm._e()]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };